/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-16 18:19:40
 * @LastEditTime: 2025-01-21 16:39:02
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\teachins\details\index.tsx
 * @Description: 
 */
import FileDisplay from "@/components/file_display";
import ModuleCont from "@/components/moduleCont";
import IcoQrcode from '@/images/statistic/qrcode.svg';
import { CommmonGet } from "@/util/network/api";
import { useTopHeight96 } from "@/util/public";
import { downloadFile, previewFile } from "@/util/util";
import { Spin } from "antd";
import { LgSealMark } from "lancoo-web-ui";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './index.scss';
import StatusTips from "@/components/statusTips";
import { nameTips } from "../common/publicFunc";
import { OptionFunContext } from "../data";

function TeachinsDetails() {

  const service = {
    detail: '/portal/teachIn/detail',
  }

  // 页面处理
  useTopHeight96();

  const optionFun = useContext(OptionFunContext);

  const location = useLocation();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id')

  // 刷新
  const [isloading, setIsloading] = useState<boolean>(false);

  const [info, setInfo] = useState<any>({});

  useEffect(() => {
    init();
  }, [id])

  const init = () => {
    setIsloading(true);
    CommmonGet(service.detail + '/' + id).then((res: any) => {
      setInfo(res?.data || {});
    }).catch(error => {
      console.log(error);
    }).finally(() => { setIsloading(false); })
  }

  const newPage = (infoId) => {
    // CommmonGet(service.countViews + `/${id}`).then((res: any) => {
    //   console.log(res);
    // })
    window.scrollTo(0, 0);
    navigate(`/teachins/details?id=${infoId}`)
  }

  return (
    <div className="teachinDetails">
      <Spin spinning={isloading}>
        {info?.registered &&
          <LgSealMark status="passed" style={{ width: 98, opacity: 0.5 }} >
            已登记
          </LgSealMark>
        }
        <div className="teachIn_title">
          {info?.tiName}
          {info?.tiName && <StatusTips
            style={{ color: nameTips(info?.state || 0).color }}
            text={nameTips(info?.state || 0).text}
          />}
        </div>
        <div className="teachIn_desc">
          <span style={{ marginRight: 30 }}>
            发布时间：{info?.releaseTime || '--'}
          </span>
          <span>浏览次数：{info?.pageView || '--'}次</span>
        </div>

        <div className="spit"></div>

        <div className="con_list">
          <div className="list">
            <div
              className="coverimg"
              style={{
                backgroundImage: `url(${info?.coverImgs?.[0]?.preUrl || ''})`,
              }}
            >
            </div>
            <div className="moremsg">
              <div style={{ marginBottom: 8 }}>
                所属招生计划:
                <span className="content">
                  {info?.planName || '--'}
                </span>
              </div>
              <div style={{ marginBottom: 8 }}>
                负责教师:
                <span className="content">
                  {info?.tiTeacher?.split("~")?.[1] || '--'}
                </span>
                联系电话:
                <span className="content">
                  {info?.tiMobile || '--'}
                </span>
              </div>
              <div style={{ marginBottom: 8 }}>
                地点:
                <span className="content">
                  {(info?.classroomStatus === null || info?.classroomStatus === undefined) ? (info?.tiLocation ? info?.tiLocationType == 1 ? '校内/' : '校外/' : '') : ''}
                  {(info.tiLocationType == 1 && !info.locationId) ? info.tiLocation.split('~')[1] : info.tiLocation}
                </span>
              </div>
              <div style={{ marginBottom: 8 }}>
                宣讲会日期:
                <span className="content">
                  {
                    info?.tiStartTime?.slice?.(0, info?.tiStartTime?.length - 3) + '~' +
                    info?.tiEndTime?.slice?.(0, info?.tiEndTime?.length - 3)
                  }
                </span>
              </div>
              <div style={{ marginBottom: 8 }}>
                备注:
                <span className="content">
                  {info?.tiContent || '--'}
                </span>
              </div>
            </div>
          </div>

        </div>
        {/* <ModuleCont title='宣讲会资料' section={1}>
          <div className="con_list">
            <div className="list">
              <div className="moremsg">
                <div style={{ marginBottom: 8 }}>
                  <span className="content">
                    <div dangerouslySetInnerHTML={{ __html: info?.tiContent || '暂无' }}></div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ModuleCont> */}

        {info?.enclosures?.length > 0 &&
          <ModuleCont title='资料文件下载' section={2}>
            {
              info?.enclosures?.map((ele: any) => {
                return <FileDisplay
                  download={() => { downloadFile(ele?.url || ele?.preUrl, ele?.originalName || ele?.name) }}
                  show={() => { previewFile(ele) }}
                  key={ele?.md5Id || ele?.resId}
                  file={ele?.originalName}
                  panel
                />
              })
            }
          </ModuleCont>
        }
      </Spin>
      <div className="spit" style={{ marginBottom: 20 }}></div>
      <div className="pro_nex">
        <div>
          {info?.preTeachIn?.tiName && <div onClick={() => { newPage(info.preTeachIn.id) }} style={{ cursor: 'pointer' }}>
            上一篇：
            <span className="onclik_cls">
              {info?.preTeachIn?.tiName}
            </span>
          </div>}
        </div>
        {info?.nextTeachIn?.tiName && <div onClick={() => { newPage(info.nextTeachIn.id) }} style={{ cursor: 'pointer' }}>
          下一篇：
          <span className="onclik_cls">
            {info?.nextTeachIn?.tiName}
          </span>
        </div>
        }
      </div>

      {info?.id && !(info?.state > 1 || (info?.classroomStatus && info?.classroomStatus !== 0)) &&
        <div className="signup-now">
          {!info?.registered ?
            <div className="ima" onClick={() => optionFun.enroll(info)} />
            : <>
              <div className="imaNot" />
              {info?.registered && <span className="onclik_cls" onClick={() => optionFun.enroll(info)}>查看登记信息</span>}
            </>
          }
        </div>
      }
    </div>
  )
}

export default TeachinsDetails
